import { coreActions } from '@sonar-software/sonar-core';
import { useAction } from '@hooks';
import { Col, Row } from 'antd';
import {
	InitiativeOwnersSummary,
	InitiativeScopeSummary,
	InitiativeStakeholdersSummary,
	InitiativeTasksSummary
} from '.';
import React, { useEffect } from 'react';

export interface InitiativeSummaryProps {
	initiativeId: number;
}

export const InitiativeSummary: React.FC<InitiativeSummaryProps> = ({ initiativeId }) => {
	const getSummary = useAction(coreActions.requestGetCoreInitiativesSummary);

	useEffect(() => {
		if (initiativeId) {
			getSummary({ initiativeId });
		}
	}, [ getSummary, initiativeId ]);

	return (
		<div id='initiative-summary'>
			<InitiativeScopeSummary initiativeId={ initiativeId } />
			<InitiativeTasksSummary initiativeId={ initiativeId } />
			<Row gutter={ 32 }>
				<Col>
					<InitiativeOwnersSummary initiativeId={ initiativeId } />
				</Col>
				<Col>
					<InitiativeStakeholdersSummary initiativeId={ initiativeId } />
				</Col>
			</Row>
		</div>
	);
};
